var map = {
	"./quotation_01ECB4.png": "ec76",
	"./quotation_FF9E45.png": "c683",
	"./title/中国具身智能创新.png": "22f4",
	"./title/十大创新奖.png": "a0c0",
	"./title/年度最佳Ai手机智能助手.png": "5b4d",
	"./title/年度最佳Ai笔记本.png": "74f8",
	"./title/年度最佳MPV.png": "2755",
	"./title/年度最佳SUV.png": "6652",
	"./title/年度最佳冰箱.png": "ba36",
	"./title/年度最佳净水机.png": "0ce9",
	"./title/年度最佳创新家电.png": "d6d7",
	"./title/年度最佳创新硬件.png": "07fb",
	"./title/年度最佳国产AI智能助手.png": "976a",
	"./title/年度最佳平板电脑.png": "51f8",
	"./title/年度最佳影像手机.png": "8e06",
	"./title/年度最佳性能笔记本.png": "8743",
	"./title/年度最佳扫地机器人.png": "ccc6",
	"./title/年度最佳折叠屏手机.png": "3a11",
	"./title/年度最佳教育硬件.png": "a32f",
	"./title/年度最佳新出行.png": "0ed3",
	"./title/年度最佳旗舰手机.png": "4f59",
	"./title/年度最佳智能手表.png": "3de3",
	"./title/年度最佳智能眼镜.png": "f89c",
	"./title/年度最佳智驾系统.png": "19e6",
	"./title/年度最佳洗地机.png": "7a93",
	"./title/年度最佳洗碗机.png": "ccde",
	"./title/年度最佳洗衣机.png": "c6ca",
	"./title/年度最佳烟机灶具.png": "b120",
	"./title/年度最佳热水器.png": "e5c6",
	"./title/年度最佳电竞手机.png": "fe32",
	"./title/年度最佳电视.png": "097e",
	"./title/年度最佳相机.png": "f30d",
	"./title/年度最佳空调.png": "4af9",
	"./title/年度最佳耳机.png": "3ebc",
	"./title/年度最佳蒸烤一体机.png": "fd5d",
	"./title/年度最佳路由器.png": "418a",
	"./title/年度最佳轿车.png": "0fb1",
	"./title/最具潜力新能源车.png": "2821",
	"./title/最受欢迎新能源车.png": "46d9",
	"./title/极果出品.png": "04aa",
	"./中国具身智能创新/优必选工业人形机器人Walker S1.png": "f67f",
	"./中国具身智能创新/宇树机器人G1.png": "28df",
	"./中国具身智能创新/联想晨星足式机器人IS.png": "1d5d",
	"./十大创新奖/OPEN AI SORA.png": "8f1f",
	"./十大创新奖/TCL华星印刷OLED.png": "2764",
	"./十大创新奖/三星Galaxy Ring.png": "bf82",
	"./十大创新奖/华为 Mate XT非凡大师.png": "16bb",
	"./十大创新奖/华为XT.png": "03e0",
	"./十大创新奖/华为红枫影像技术.png": "cd4f",
	"./十大创新奖/大疆 DJI Air 3S 无人机.png": "e27e",
	"./十大创新奖/大疆AVINOX DRIVER SYSTEM（山地车助力系统）.png": "2bac",
	"./十大创新奖/摩尔线程 MTT KUAE 智算中心全栈解决方案.png": "62cc",
	"./十大创新奖/比亚迪易三方.png": "9251",
	"./十大创新奖/纯血鸿蒙.png": "a924",
	"./十大创新奖/联想ThinkBook Plus 卷轴屏笔记本电脑.png": "ee64",
	"./年度最佳Ai手机智能助手/华为-小艺.png": "4146",
	"./年度最佳Ai手机智能助手/小米-小爱同学.png": "a8f1",
	"./年度最佳Ai手机智能助手/荣耀-YOYO.png": "86b0",
	"./年度最佳Ai笔记本/华为 HUAWEI MateBook X Pro.png": "7cdc",
	"./年度最佳Ai笔记本/联想ThinkPad X1 Carbon Gen 13.png": "0d8e",
	"./年度最佳Ai笔记本/荣耀 MagicBook Art 14.png": "797c",
	"./年度最佳MPV/岚图梦想家.png": "641a",
	"./年度最佳MPV/极氪009.png": "cd0b",
	"./年度最佳MPV/腾势D9.png": "0323",
	"./年度最佳SUV/智界R7.png": "0c9a",
	"./年度最佳SUV/问界M7 Ultra.png": "8b17",
	"./年度最佳SUV/魏牌蓝山.png": "8f07",
	"./年度最佳冰箱/方太平嵌式高端系列.png": "312a",
	"./年度最佳冰箱/松下大海豚系列.png": "bf1c",
	"./年度最佳冰箱/美的M60系列.png": "1f7c",
	"./年度最佳净水机/A.O.史密斯橱下冷热即饮净水机DR4000DC1.png": "dfc2",
	"./年度最佳净水机/九阳太空热小净R5P.png": "965d",
	"./年度最佳净水机/安吉尔空间大师系列M7 Home Pro 800.png": "83c2",
	"./年度最佳创新家电/华为智慧屏V5.png": "dd6f",
	"./年度最佳创新家电/卡萨帝艺术电视 壁画M70.png": "2684",
	"./年度最佳创新家电/米家双区洗双洗烘洗衣机.png": "95ac",
	"./年度最佳创新硬件/AISON爱畅K歌音箱.png": "302a",
	"./年度最佳创新硬件/极空间 T2S智能魔盒.png": "220d",
	"./年度最佳创新硬件/讯飞AI会议耳机Pro 2.png": "d103",
	"./年度最佳国产AI智能助手/Kimi.png": "1e25",
	"./年度最佳国产AI智能助手/讯飞星火.png": "5fef",
	"./年度最佳国产AI智能助手/豆包.png": "03a3",
	"./年度最佳平板电脑/vivo Pad3 Pro.png": "4317",
	"./年度最佳平板电脑/华为 HUAWEI MatePad Pro.png": "41a5",
	"./年度最佳平板电脑/苹果 Apple iPadPro 13英寸（M4）.png": "26c0",
	"./年度最佳影像手机/OPPO Find X8 Pro.png": "3f50",
	"./年度最佳影像手机/vivo X200 Pro.png": "9dd1",
	"./年度最佳影像手机/华为 HUAWEI Mate 70 Pro+.png": "c53d",
	"./年度最佳性能笔记本/惠普战99 AI商务超能本.png": "b025",
	"./年度最佳性能笔记本/联想 拯救者Y7000P.png": "488b",
	"./年度最佳性能笔记本/苹果 Apple MacBookPro M4.png": "0acc",
	"./年度最佳扫地机器人/3i 智能净地站 F1.png": "5eb5",
	"./年度最佳扫地机器人/石头扫拖一体 P20 Pro.png": "85c8",
	"./年度最佳扫地机器人/科沃斯地宝T50 PRO.png": "287b",
	"./年度最佳折叠屏手机/华为Mate X6.png": "3804",
	"./年度最佳折叠屏手机/小米 MIX Flip.png": "88ed",
	"./年度最佳折叠屏手机/荣耀 Magic V3.png": "6266",
	"./年度最佳教育硬件/噜咔博士AI拍学机.png": "fb8b",
	"./年度最佳教育硬件/学而思教育平板xPad.png": "37a8",
	"./年度最佳教育硬件/科大讯飞AI学习机T30 Ultra.png": "e7e0",
	"./年度最佳新出行/九号电动T自平衡探索版.png": "54fb",
	"./年度最佳新出行/大疆AVINOX DRIVER SYSTEM（山地车助力系统）.png": "ab21",
	"./年度最佳新出行/雅迪冠能星舰S80.png": "58d7",
	"./年度最佳旗舰手机/华为 HUAWEI Mate 70 Pro.png": "dc8e",
	"./年度最佳旗舰手机/小米15Pro.png": "0fba",
	"./年度最佳旗舰手机/苹果 iPhone 16 Pro Max.png": "0033",
	"./年度最佳智能手表/华为 HUAWEI WATCH D2.png": "3702",
	"./年度最佳智能手表/华为 HUAWEI Watch GT 5.png": "67e8",
	"./年度最佳智能手表/苹果Apple Watch Series 10.png": "847c",
	"./年度最佳智能眼镜/Rokid Glasses.png": "592d",
	"./年度最佳智能眼镜/XREAL Air 2 Pro.png": "8f22",
	"./年度最佳智能眼镜/雷朋 RayBan Meta Smart Glasses.png": "7dc5",
	"./年度最佳智驾系统/HUAWEI ADS 系统.png": "b4da",
	"./年度最佳智驾系统/小鹏XNGP系统.png": "281c",
	"./年度最佳智驾系统/理想AD MAX系统.png": "5c78",
	"./年度最佳洗地机/添可芙万ArtStation美学空间站.png": "0efd",
	"./年度最佳洗地机/莱克天王星多功能洗地吸尘器.png": "6da5",
	"./年度最佳洗地机/追觅洗地机T40系列.png": "553e",
	"./年度最佳洗碗机/A.O.史密斯自旋式洁霸洗碗机R5.png": "09bd",
	"./年度最佳洗碗机/方太VP10.png": "96c6",
	"./年度最佳洗碗机/美的晶焰万向洗碗机.png": "a02d",
	"./年度最佳洗衣机/TCL超级筒T7H.png": "f9b2",
	"./年度最佳洗衣机/石头分子筛洗烘一体机Z1 Pro.png": "21ea",
	"./年度最佳洗衣机/美的纯平全嵌洗烘套装.png": "dccb",
	"./年度最佳烟机灶具/A.O.史密斯「瀞」油烟机.png": "ff82",
	"./年度最佳烟机灶具/方太F3 纤薄顶吸烟机灶具套装.png": "e773",
	"./年度最佳烟机灶具/老板小黑翼D1 超薄顶侧双吸烟灶套装.png": "2e7a",
	"./年度最佳热水器/佳尼特 蓝鲸TJ3.png": "6cc2",
	"./年度最佳热水器/林内鲸吨吨虎鲸.png": "b209",
	"./年度最佳热水器/美的无冷感燃气热水器S9.png": "62cb",
	"./年度最佳电竞手机/iQOO 13.png": "87c2",
	"./年度最佳电竞手机/一加 13.png": "ba77",
	"./年度最佳电竞手机/红魔 10Pro+.png": "3b0a",
	"./年度最佳电视/TCL QD-Mini LED电视X11H.png": "f75f",
	"./年度最佳电视/海信（Hisense） U8N Pro.png": "3daa",
	"./年度最佳电视/索尼（Sony） XR90.png": "3092",
	"./年度最佳相机/佳能 Canon EOS R6 Mark II.png": "5a39",
	"./年度最佳相机/徕卡Q3 43.png": "27f6",
	"./年度最佳相机/索尼 SONY Alpha 1 II.png": "14cc",
	"./年度最佳空调/格力风不吹人空调.png": "321a",
	"./年度最佳空调/海尔聪明风空调.png": "ea9e",
	"./年度最佳空调/美的风尊二代pro空调.png": "44b6",
	"./年度最佳耳机/OPPO Enco X3.png": "6002",
	"./年度最佳耳机/华为 HUAWEI FreebudsPro3.png": "9a1c",
	"./年度最佳耳机/苹果Apple AirPods4降噪版.png": "fb93",
	"./年度最佳蒸烤一体机/方太蒸烤炸炖一体机 EP1.png": "3530",
	"./年度最佳蒸烤一体机/松下微蒸烤炸一体机 DS37.png": "fc93",
	"./年度最佳蒸烤一体机/美的微霸系列微蒸烤炸炖五合一 GR6.png": "0279",
	"./年度最佳路由器/华为 HUAWEI 凌霄子母路由器.png": "78a1",
	"./年度最佳路由器/新华三 H3C BE18000.png": "6c10",
	"./年度最佳路由器/锐捷Ruijie天蝎BE72Pro.png": "44c5",
	"./年度最佳轿车/小米SU7.png": "9ff6",
	"./年度最佳轿车/腾势Z9GT.png": "06a3",
	"./年度最佳轿车/蔚来ET7行政版.png": "a2e8",
	"./最具潜力新能源车/小鹏 P7+.png": "6ada",
	"./最具潜力新能源车/方程豹 豹8.png": "299f",
	"./最具潜力新能源车/智界 S7.png": "9983",
	"./最受欢迎新能源车/特斯拉Model Y.png": "4bd1",
	"./最受欢迎新能源车/理想 L6.png": "a712",
	"./最受欢迎新能源车/问界 M9.png": "168b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0c5";